import "./style.scss";
import $ from 'jquery';

$(document).ready(function () {
    // Dynamic list
    $('.dynamic-list .dynamic-list__bullet').on('click', function () {
        $('.dynamic-list .dynamic-list__bullet').removeClass('active');
        $(this).addClass('active');
        // $('.dynamic-list .dynamic-list__bullet').each(function () {
        //     // $(this).slideUp();
        //     $(this).removeClass('active');
        // });
    });
});